import {
  ConsultantPresentationCountry,
  ConsultantPresentationType,
  ConsultantReferenceDocument,
  GetConsultantCreatePresentationDataQuery,
  UserDataFragment
} from "@bonliva-crm/graphql";
import {
  EmailEditorFormValues,
  emailEditorFormSchema
} from "@consultants/consultant-profile-new/email-editor/form-values";

import * as yup from "yup";

export type FirstFormValues = {
  presentationCountry: ConsultantPresentationCountry;
  generateCV: "true" | "false";
  presentationType: ConsultantPresentationType;
  presentationText: string;
  selectedFiles: string[];
  selectedReferenceDocuments: ConsultantReferenceDocument[];
  contactPerson: UserDataFragment | null;
};

export const firstFormSchema = yup
  .object({
    presentationCountry: yup
      .string()
      .oneOf(Object.values(ConsultantPresentationCountry))
      .required(),
    generateCV: yup.string().oneOf(["true", "false"]).required(),
    presentationType: yup
      .string()
      .oneOf(Object.values(ConsultantPresentationType))
      .required(),
    presentationText: yup.string(),
    selectedFiles: yup.array(yup.string()),
    contactPerson: yup
      .object({
        _id: yup.string().required()
      })
      .required()
  })
  .required();

export type SecondFormValues = {
  presentationVerified: boolean;
};

export const secondFormSchema = yup.object({
  presentationVerified: yup.boolean().oneOf([true]).required()
});

export type ThirdFormValues = EmailEditorFormValues;

export const thirdFormSchema = emailEditorFormSchema;

export function getInitialValue(
  data: GetConsultantCreatePresentationDataQuery | null
): FirstFormValues {
  return {
    presentationCountry: ConsultantPresentationCountry.Sweden,
    generateCV: data?.consultantById.isCvDataAffected ? "true" : "false",
    presentationType: ConsultantPresentationType.NoText,
    presentationText: data?.consultantById.Intro ?? "",
    selectedFiles: [],
    selectedReferenceDocuments: [],
    contactPerson: data?.consultantById.ResponsiblePerson
      ? ({
          _id: data.consultantById.ResponsiblePerson.PersonId,
          Name: data.consultantById.ResponsiblePerson.Name
        } as UserDataFragment)
      : null
  };
}
